export default {
  userChainId: 'gandalf-user-chain-id',
  contractsFileDescriptorBase64: 'contracts-file-descriptor-base64',
};
